import SocialSR from 'libs/shared/ui/src/lib/components/my-evolution/social/social'

export const Social = () => {
  return (
    <div className="mt-10 w-full">
      <SocialSR />
    </div>
  )
}
